import { useRef, type CSSProperties, type ReactNode } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function SelectClearControl({ children, onClear, clearLabel, className, testId }: {
  children: ReactNode;
  onClear?: () => void;
  clearLabel: string;
  className?: string;
  testId?: string;
}) {
  const controlRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={controlRef}
      className={cn("relative w-full", className)}
      style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) 2rem 2rem", alignItems: "center", "--select-clear-padding": onClear ? "2.5rem" : "0rem" } as CSSProperties}
    >
      <div style={{ gridArea: "1 / 1 / 2 / 4", minWidth: 0 }}>{children}</div>
      {onClear && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-7 w-7 text-muted-foreground"
          style={{ gridArea: "1 / 2 / 2 / 3", justifySelf: "center", zIndex: 1 }}
          aria-label={clearLabel}
          title={clearLabel}
          data-testid={testId ? `${testId}-clear` : undefined}
          onClick={(event) => {
            event.stopPropagation();
            onClear();
            controlRef.current?.querySelector<HTMLButtonElement>('[role="combobox"]')?.focus();
          }}
        >
          <X className="h-3.5 w-3.5" />
        </Button>
      )}
    </div>
  );
}
